import { ChartsProps } from "./Charts.types";

import { DetailedView } from "../DetailedView";

import styles from "./ChartsDetails.module.scss";

const ChartsDetails = ({
  calculation,
  proCalculationDocument,
  post,
  onPositionChange,
  proCalculation,
  proCalculationCharts,
  activePosition,
}: ChartsProps) => {
  return (
    <div className={styles.content}>
      <DetailedView
        activePosition={activePosition}
        post={post}
        onPositionChange={onPositionChange}
        calculation={calculation}
        conclusionsPro={proCalculation?.conclusionsPro}
        proCalculationDocument={proCalculationDocument}
        proCalculationCharts={proCalculationCharts}
      />
    </div>
  );
};

export default ChartsDetails;
